function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#5B6572",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  fill: "#FFF"
}, React.createElement("path", {
  d: "M1 1h13v13H1z"
}), React.createElement("path", {
  d: "M4 4h13v13H4z"
})), React.createElement("g", {
  fill: "#F8F9FB"
}, React.createElement("path", {
  d: "M13.296 10.94l-2.47 2.47M8.356 10.94l2.47 2.47M10.826 13.412V6.857"
})));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18"
}, props), _ref);

export default __webpack_public_path__ + "static/media/icon-download.5c51c6d7.svg";
export { SvgComponent as ReactComponent };